import { BackgroundProcessor } from 'features/VirtualBackground/source';

export interface Background {
    preview: string;
    full: string;
}

export type BackgroundProcessorWrapper = ReturnType<typeof BackgroundProcessor>;

export const enum PROCESSOR_TYPES {
    none,
    blur,
    image,
}

export type ProcessorInfo =
    | { type: PROCESSOR_TYPES.none; text: string }
    | { type: PROCESSOR_TYPES.blur; blurRadius: number; text: string }
    | {
          type: PROCESSOR_TYPES.image;
          previewSrc: string;
          fullSrc: string;
      };
